export default __webpack_public_path__ + "static/media/upload-document.7c104ba0.svg";